import _ from 'lodash'
import type {
  CategoryTypes,
  SearchFilterOptions,
} from '~/composables/useSearchFilters'

export const useGiftcardEvents = async (filters: Ref<SearchFilterOptions>) => {
  const giftcardSupplierId = 'z38lrx'
  const currentFilteredCategories = ref<CategoryTypes[]>([])

  const { data: supplierEvents = ref([]) } = await useFetchSupplierEvents(
    giftcardSupplierId,
    false,
    'created_at',
    {
      transform: transformToAlgoliaEvent,
      default: () => ref([]),
    }
  )

  const filteredGiftcardEvents = computed(() => {
    return supplierEvents.value?.filter(
      (el: any) =>
        el.categories.filter((item) => {
          const includes = filters.value.categories?.includes(item.name)

          if (includes) {
            currentFilteredCategories.value.push(item.name)
          }

          return includes
        }).length > 0
    )
  })

  watch(
    filters.value,
    () => {
      currentFilteredCategories.value = _.cloneDeep(
        filters.value.categories || []
      )
    },
    { immediate: true }
  )

  return {
    giftcardEvents: supplierEvents.value,
    filteredGiftcardEvents,
  }
}
